import { render, staticRenderFns } from "./product-form-dialog.app.vue?vue&type=template&id=fe406532&"
import script from "./product-form-dialog.app.vue?vue&type=script&lang=js&"
export * from "./product-form-dialog.app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports